import { render, staticRenderFns } from "./Polish.vue?vue&type=template&id=c23ecdf8&scoped=true&"
import script from "./Polish.vue?vue&type=script&lang=js&"
export * from "./Polish.vue?vue&type=script&lang=js&"
import style0 from "./Polish.vue?vue&type=style&index=0&id=c23ecdf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23ecdf8",
  null
  
)

export default component.exports